export const ADD_NOTIFICATION = 'notification/ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'notification/REMOVE_NOTIFICATION';
export const REMOVE_ALL_NOTIFICATIONS = 'notification/REMOVE_ALL_NOTIFICATIONS';
export const REACT_ROUTER_LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
